
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateProjectrevenueDtoFormGroup() {
return new FormGroup({
    projectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    remarks: new FormControl<string | undefined>('', [Validators.required]),
    changeChf: new FormControl<number | undefined>(undefined),
    mails: new FormControl<Array<string> | undefined>([]),
})
;
}
      